import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Autoplay } from "swiper";

type Props = {
  children: any,
  loop: boolean,
  autoplay: boolean,
  delay: number,
  classSlider: string,
  classSwiper: string,
  slidesPerView: number,
  spaceBetween: number,
  pagination: boolean
};

const Slider = ({ 
    children, 
    classSlider,
    classSwiper,
    autoplay = false,
    delay = 3000, 
    loop = false,
    slidesPerView = 1,
    spaceBetween = 0,
    pagination = false,
    centeredSlides = false,
    initialSlide = 0
  } : Props) => {
  SwiperCore.use([]); 
  if(autoplay) SwiperCore.use([Autoplay]);
  if(pagination) {
    SwiperCore.use([Pagination]);
  }

    var itemSlideRender = (children && children.length > 0) && children.map((item, key) => (
        <SwiperSlide key={`slider_${key}`} className={classSwiper || ''}>
            <div className="swiper-zoom-container">
                {item}
            </div>
        </SwiperSlide>
    ));

  if(!itemSlideRender){
      itemSlideRender = <SwiperSlide key={`slider_${0}`} className={classSwiper || ''}>
          <div className="swiper-zoom-container">
              {children}
          </div>
      </SwiperSlide>
  }

  return (
    <>
        <Swiper key={classSlider}
          className={`wrap-silder ${classSlider}`} 
          spaceBetween={spaceBetween}
          slidesPerView={slidesPerView }
          pagination={pagination ? {
            clickable: true,
            type: 'bullets',
          } : false}
          loop={loop}
          autoplay={autoplay ? {
            delay: delay,
            disableOnInteraction: false
          } : false}
          centeredSlides={centeredSlides}
          initialSlide={initialSlide}
          // zoom={{
          //   maxRatio: 3,
          //   minRatio: 1,
          // }}
        >
          {itemSlideRender}
        </Swiper>
    </>
  )
}

export default Slider;
